import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import Guides from '~components/Guides'

import style from './GuideCategories.module.scss'

const GuideCategories = () => (
  <StaticQuery
    query={query}
    render={data => (   
    <div className={style.categories}>
      <Guides guides={data.guides.nodes} compact />
    </div>
    )}
  />
)


const query = graphql`
query {
  guides: allMarkdownRemark(
    limit: 10,
    sort: {fields: frontmatter___rank, order: ASC}, 
    filter: {frontmatter: {
      hide: { ne: true }, 
      type: { eq: "guide" },
      is_index: {eq: true}, 
      category_id: {ne: null}, 
      subcategory_id: {eq: null}
  }}) {
    nodes {
      id
      title
      path
      subcategories {
        id
        title
        path
      }
      subPages {
        id
        title
        path
      }
      quickstarts {
        id
        title
        path
      }
    }
  }
}
`

export default GuideCategories